import Promobot from '@pb/api';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store/index';
import router from '@/router/index';
import i18nOptions from '@/locales/index';
import staticData from '@/plugins/staticData';
import promobot from '@/plugins/promobot';
import axios from '@/plugins/axios';
import App from '@/App.vue';
import '@/helpers/filters';

Vue.config.productionTip = false;

const getPromobotInstance = () => {
  // Браузерный эмулятор
  if (process.env.VUE_APP_USE_BROWSER_EMULATOR) {
    return window.promobotBrowserEmulator.getInstance();
  }

  // QWebChannel
  if (typeof QWebChannel !== 'undefined') {
    return Promobot.getInstance();
  }

  // Демо эмулятор
  return Promobot.getEmulateInstance({
    url: 'http://localhost:8089',
    reconnection: false,
    secure: false,
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  const robotInstance = await getPromobotInstance();

  window.robot = robotInstance;

  Vue.use(promobot, robotInstance);
  Vue.use(axios, store);
  Vue.use(staticData);
  Vue.use(VueI18n);

  new Vue({
    i18n: new VueI18n(i18nOptions),
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
